// TODO: Add
const DEMON_CONTRACT_ADDRESS = "0xa12145f71AA440cA83856e44Fe79228b7fB06FaF";
const HELL_CONTRACT_ADDRESS = "0x7B7dAd77E4090160F9cB6BA57A5a774c12D4c28a";
const KEY_CONTRACT_ADDRESS = "0x50ae01eC60059B60b6F36f4723c939Cb8FaaaC05";

export {
  DEMON_CONTRACT_ADDRESS,
  HELL_CONTRACT_ADDRESS,
  KEY_CONTRACT_ADDRESS
};